import "../loading/loading.css";

const Loading = () => {
  return <div class="loader"></div>;
};
export default Loading;
